import { uiSize } from '@utils'

interface Props {
  color?: string
  size?: number | string
}

function RecurringPaymentsIcon({ color = 'var(--banky-royal-blue)', size = 18 }: Props) {
  return (
    <svg width={uiSize(size)} height={uiSize(size)} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18 18' fill='none'>
      <path
        d='M13.5 5.25H5.25a2.25 2.25 0 0 0-2.25 2.25v1.5'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M11.25 2.75 13.5 5l-2.25 2.25' stroke={color} strokeLinecap='round' strokeLinejoin='round' />
      <path
        d='M4.5 12.75h8.25a2.25 2.25 0 0 0 2.25-2.25v-1.5'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M6.75 15.25 4.5 13l2.25-2.25' stroke={color} strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  )
}

export default RecurringPaymentsIcon
